import { Menu } from "lucide-react";

const NavLoading = () => {
  return <nav className="w-full flex items-center justify-start gap-x-7 py-4 text-sm text-jmt-neutral-700">

    <div className="flex items-center gap-1.5 hover:text-jmt-main transition-colors">
      <Menu size={20} className="text-jmt-neutral-900" />
      <span>دسته‌بندی محصولات</span>
    </div>

    <div className="bg-jmt-neutral-100 h-5 w-[110px] xl:w-[145px] rounded-md" />
    <div className="bg-jmt-neutral-100 h-5 w-[110px] xl:w-[145px] rounded-md" />
    <div className="bg-jmt-neutral-100 h-5 w-[110px] xl:w-[145px] rounded-md" />
    <div className="bg-jmt-neutral-100 h-5 w-[110px] xl:w-[145px] rounded-md" />
    <div className="bg-jmt-neutral-100 h-5 w-[110px] xl:w-[145px] rounded-md" />

  </nav>;
};

export default NavLoading;